import React, { useCallback, useEffect, useState } from "react";
import { Dash, Plus, Trash } from "../../../assets/svg/AllSvg";
import { InputWithLabel } from "../../../components/micro";
import ReactSelect from "react-select";
import { getCountryData } from "../../../redux/address/slice";
import { useDispatch, useSelector } from "react-redux";

const NewShareholder = ({
  noOfShareholder,
  setNoOfShareholder,
  newShareholderNameArray,
  setNewShareholderArray,
}) => {
  const [countryArray, setCountryArray] = useState([]);

  const dispatch = useDispatch();

  // Selector
  const { countryData, countryLoading } = useSelector((store) => ({
    countryData: store?.addressData?.getCountryDataStatus?.data,
    countryLoading: store?.addressData?.getCountryDataStatus?.loading,
  }));

  useEffect(() => {
    if (!countryData?.data?.length) {
      dispatch(getCountryData());
    }
  }, [dispatch]);

  useEffect(() => {
    if (countryData?.data) {
      const data = countryData?.data?.map((x) => ({
        ...x,
        label: x?.name,
      }));
      setCountryArray(data);
    }
  }, [countryData]);

  // Add director
  useEffect(() => {
    if (noOfShareholder > 0) {
      const newShareholder = Array.from({ length: noOfShareholder }, () => ({
        shareholder_type: "",
        shareholder_nationality: "",
        shareholder_name: "",
        shareholder_email: "",
      }));
      setNewShareholderArray(newShareholder);
    } else {
      setNewShareholderArray([]);
    }
  }, [noOfShareholder]);

  // Remove New Shareholder
  const removeShareholderInformation = useCallback(
    (index) => {
      setNewShareholderArray((prev) => [
        ...prev.slice(0, index),
        ...prev.slice(index + 1),
      ]);
      setNoOfShareholder((prevCount) => Math.max(0, prevCount - 1));
    },
    [setNewShareholderArray]
  );

  // Increment
  const handleEpIncrement = () => {
    setNoOfShareholder((prevCount) =>
      prevCount < 9 ? prevCount + 1 : prevCount
    );
  };

  // Decrement
  const handleEpDecrement = () => {
    setNoOfShareholder((prevCount) =>
      prevCount > 1 ? prevCount - 1 : prevCount
    );
  };

  // Update Shareholder
  const updateShareholderInformation = useCallback(
    (index, field, value) => {
      setNewShareholderArray((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, [field]: value } : item
        )
      );
    },
    [setNewShareholderArray]
  );

  const shareholderTypeOptions = [
    { label: "Individual Shareholder", value: "individual" },
    { label: "Corporate Shareholder", value: "corporate" },
  ];

  return (
    <>
      <div className="space-y-3">
        <p>How many new shareholder are you adding?</p>
        <div className="flex items-center max-w-[8rem]">
          <button
            type="button"
            idFromName={"numberOfDirector"}
            onClick={handleEpDecrement}
            className="bg-lightPrimary2 hover:bg-bgPrimary rounded-l-lg px-3 h-11"
          >
            <Dash />
          </button>
          <input
            type="text"
            id="quantity-input"
            aria-describedby="helper-text-explanation"
            className="bg-lightPrimary2 h-11 text-center text-theme text-sm block w-full "
            value={noOfShareholder}
            readOnly
          />
          <button
            type="button"
            idFromName={"numberOfDirector"}
            onClick={handleEpIncrement}
            className="bg-lightPrimary2 hover:bg-bgPrimary rounded-r-lg px-3 h-11"
          >
            <Plus className="fill-theme" />
          </button>
        </div>
        {newShareholderNameArray.map((element, index) => {
          return (
            <div
              className={`space-y-3 ${
                !(newShareholderNameArray.length - 1 === index) &&
                "pb-5 border-b-2 border-secondary_grey"
              }`}
            >
              <div className="flex justify-between items-center">
                <p>New Shareholder {index + 1} Details:</p>
                {newShareholderNameArray.length > 1 && (
                  <button
                    className="p-4"
                    onClick={() => removeShareholderInformation(index)}
                  >
                    <Trash />
                  </button>
                )}
              </div>
              <div className="space-y-3">
                {/* Shareholder Type */}
                <ReactSelect
                  className={"p-0"}
                  id="shareholder_type"
                  placeholder="Shareholder Type"
                  is
                  options={shareholderTypeOptions}
                  isClearable={true}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  value={
                    shareholderTypeOptions?.length > 0 &&
                    shareholderTypeOptions?.find((op) => {
                      return op.value === element.shareholder_nationality;
                    })
                  }
                  onChange={(e) => {
                    updateShareholderInformation(
                      index,
                      "shareholder_type",
                      e.value
                    );
                  }}
                  isLoading={false}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: `1px solid #cdddeb`,
                      borderRadius: "0.3rem",
                      paddingTop: "2px",
                      paddingBottom: "2px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #cdddeb",
                      },
                    }),
                  }}
                />
                {/* Shareholder Nationality */}
                <ReactSelect
                  className={"p-0"}
                  id="shareholder_nationality"
                  placeholder="Shareholder Nationality"
                  options={countryArray}
                  isLoading={countryLoading}
                  isClearable={true}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.id}
                  value={
                    countryArray?.length > 0 &&
                    countryArray?.find((op) => {
                      return op.id === element.shareholder_nationality;
                    })
                  }
                  onChange={(e) => {
                    updateShareholderInformation(
                      index,
                      "shareholder_nationality",
                      e.id
                    );
                  }}
                  styles={{
                    control: (base) => ({
                      ...base,
                      border: `1px solid #cdddeb`,
                      borderRadius: "0.3rem",
                      paddingTop: "2px",
                      paddingBottom: "2px",
                      boxShadow: "none",
                      "&:hover": {
                        border: "1px solid #cdddeb",
                      },
                    }),
                  }}
                />
                {/* Shareholder Name */}
                <InputWithLabel
                  className={"border"}
                  label={"Shareholder Name"}
                  idFromName={"shareholder_name"}
                  type={"text"}
                  value={element.shareholder_name}
                  onChange={(e) => {
                    updateShareholderInformation(
                      index,
                      "shareholder_name",
                      e.target.value
                    );
                  }}
                />
                {/* Shareholder Email */}
                <InputWithLabel
                  className={"border"}
                  label={"Shareholder Email"}
                  idFromName={"shareholder_email"}
                  type={"email"}
                  value={element.shareholder_email}
                  onChange={(e) => {
                    updateShareholderInformation(
                      index,
                      "shareholder_email",
                      e.target.value
                    );
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default NewShareholder;
